<template>
  <help-info-wrapper
    :info.sync="helpData"
    :service-name="serviceName"
    class="warp"
  >
    <template>
      <v-row no-gutters>
        <v-col cols="12">
          <v-progress-linear v-if="loading" indeterminate />
        </v-col>

        <v-col cols="12" md="6">
          <v-card-text>
            <div class="rowinfo">
              <v-text-field
                v-show="!!computedValue.vat"
                v-model="computedValue.vat"
                class="rounded-lg"
                clear-icon="mdi-close-circle-outline"
                clearable
                dense
                label="درصد مالیات"
                outlined
                type="number"
              />
              <help-info
                :element-name="`${serviceName}-${componentName}-computedValue-vat`"
                :service-name="serviceName"
                :help-data="helpData"
                class="buttoninfo"
                label="درصد مالیات"
              />
            </div>
          </v-card-text>
        </v-col>

        <v-col cols="12" md="6">
          <v-card-text class="py-0">
            <v-switch
              v-model="computedValue.vat"
              dense
              inset
              label="مالیات"
              @change="(e) => (computedValue.vat = !!e ? 10 : null)"
            />
            <v-switch
              v-model="computedValue.online_pay"
              dense
              inset
              label="پرداخت آنلاین"
              @change="onChange($event, 'online_pay')"
            />
            <v-switch
              v-model="computedValue.pay_in_person_place"
              dense
              inset
              label="پرداخت در زمان نوبت"
              @change="onChange($event, 'pay_in_person_place')"
            />
            <v-switch
              v-model="computedValue.send_appointment_sms"
              dense
              inset
              label="ارسال پیامک رزرو نوبت به مشتری"
            />
            <!--        <v-switch dense disabled inset label="ارسال پیامک اطلاع از رزرو نوبت‌ها"/>-->
          </v-card-text>
        </v-col>
      </v-row>
    </template>
  </help-info-wrapper>
</template>

<script>
export default {
  name: "appointmentReserveManager",

  props: {
    value: Object,
  },

  data: () => ({
    helpData: [],
    serviceName: "Qrland",
    componentName: "appointment-reserve-manager",
    vat: false,
    loading: false,
  }),

  computed: {
    computedValue: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit("input", val);
      },
    },
  },

  methods: {
    onChange(state, field) {
      this.computedValue[field] = !!state ? 1 : 0;

      const _this = this;
      let pay = ["pay_in_person_place", "online_pay"];

      check(pay);

      function check(arr) {
        if (arr.includes(field)) {
          let f = arr.map((item) => !!_this.computedValue[item]);
          if (!_this.computedValue[field] && f.every((e) => !e)) {
            let index = arr.findIndex((item) => item === field);
            arr.splice(index, 1);
            _this.computedValue[arr[0]] = 1;
          }
        }
      }
    },
  },
};
</script>

<style scoped></style>
